import React, { useState } from "react";
import Navigation from "../Navigation";
import Footer from "../Footer";
import FooterDownload from "../FooterDownload";
import { linkConfig } from "../../config";
import styles from "./styles.module.scss";
import { parse } from "qs";
import { useLocation } from "react-router-dom";

export default ({
  children,
  className = "",
  retModalOne_title = "开户可领取50元红包,确定放弃吗？",
  retModalOne_confirmTxt = "继续领取",
  retModalOne_cancelTxt = "确认放弃",
  retModalTwo_title = "下载APP领取$11000赠金！",
  retModalTwo_confirmTxt = "谘询客服",
  isPageSkipDisplay = false,
}) => {
  const [retModalOneVisible, setRetModalOneVisible] = useState(false);
  const [retModalTwoVisible, setRetModalTwoVisible] = useState(false);

  const location = useLocation();
  const params = parse(location.search.slice(1));

  const isApp = () => {
    if (params.from instanceof Array) {
      return params.from.includes("app");
    } else {
      return params.from === "app";
    }
  };
  const clientWidth = document.body.clientWidth || 1080;
  const isPcView = clientWidth > 1080;
  const isNotFooterDownloadShow = isApp() || isPcView;

  const toggleRetModalOne = () => {
    setRetModalOneVisible((t) => !t);
  };

  const toggleRetModalTwo = () => {
    setRetModalOneVisible((t) => !t);
    setRetModalTwoVisible((t) => !t);
  };

  const handleAgainConfirm = () => {
    window.location.href = linkConfig.online;
  };

  return (
    <main>
      <Navigation submit={toggleRetModalOne} />
      <div className={`${styles.main} ${className}`}>
        {children}
        {isPageSkipDisplay && (
          <div className="skip-btn" onClick={toggleRetModalOne}>
            {" "}
            跳过{" "}
          </div>
        )}
      </div>

      {/* 第一个挽留弹窗 */}
      {retModalOneVisible && (
        <div className={styles.modal}>
          <div>
            <h3>{retModalOne_title}</h3>
            <div>
              <span className={styles.button1} onClick={toggleRetModalOne}>
                {retModalOne_confirmTxt}
              </span>
              <span className={styles.button2} onClick={toggleRetModalTwo}>
                {retModalOne_cancelTxt}
              </span>
            </div>
          </div>
        </div>
      )}

      {/* 第二个挽留弹窗 */}
      {retModalTwoVisible && (
        <div className={styles.modal}>
          <div className={styles.modalTwo}>
            <h3>{retModalTwo_title}</h3>
            <div>
              <span className={styles.button1} onClick={handleAgainConfirm}>
                {retModalTwo_confirmTxt}
              </span>
              {/* 无品牌开户挽留弹窗二没有取消按钮，但为了维持与其他开户的一致性，故保留此部分 */}
              <span className={styles.button2}>&nbsp;</span>
            </div>
          </div>
        </div>
      )}
      <Footer />
      {isNotFooterDownloadShow ? null : <FooterDownload />}
    </main>
  );
};
